export function getDiscountTypeCapabilities(discountTypes, selectedDiscountType) {
  if (!Array.isArray(discountTypes)
    || selectedDiscountType === null
    || typeof selectedDiscountType === 'undefined') {
    return null;
  }

  const discountType = discountTypes.find(
    (item) => `${item.value}` === `${selectedDiscountType}`,
  );
  const capabilityNames = [
    'requires_partner',
    'uses_product_catalogue',
    'uses_operation_types',
    'requires_code',
  ];

  if (!discountType || capabilityNames.some(
    (capability) => typeof discountType[capability] !== 'boolean',
  )) {
    return null;
  }

  return {
    requiresPartner: discountType.requires_partner,
    usesProductCatalogue: discountType.uses_product_catalogue,
    usesOperationTypes: discountType.uses_operation_types,
    requiresCode: discountType.requires_code,
  };
}

export function buildDiscountCatalogueUrl(path, partnerId) {
  const normalizedPartnerId = Number.parseInt(partnerId, 10);

  if (!Number.isInteger(normalizedPartnerId) || normalizedPartnerId <= 0) {
    return path;
  }

  return `${path}?partner_id=${encodeURIComponent(normalizedPartnerId)}`;
}
